import {DiscountModel} from "../Models/ProductModel";

export const useGetDiscount = (): (discounts: DiscountModel[], now: Date) => DiscountModel | undefined => {

    return (discounts: DiscountModel[], now: Date): DiscountModel | undefined => {
        return discounts.find(d => new Date(d.startedAt).getTime() < now.getTime() && new Date(d.endedAt).getTime() > now.getTime())
    }
}
